import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MachineApiService {

  constructor(private http: HttpClient) { }
    /*** ---------duplikace putMachineType v machine-column-dialog.component----- */
    /*** MachineList */
    public postMachine(params): Observable<any> {
        return this.http.post('/api/machine-list', params);
    }

    public getMachineListByType(typeId, params): Observable<any> {
        return this.http.get('/api/machine-list/type/' + typeId, {params: params});
    }

    public getMachine(id): Observable<any> {
        return this.http.get('/api/machine-list/' + id);
    }

    public putMachine(id, params): Observable<any> {
        return this.http.put('/api/machine-list/' + id, params);
    }

    public deleteMachine(id): Observable<any> {
        return this.http.delete('/api/machine-list/' + id);

    }
    public postMachineAttachment(id, file): Observable<any> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return this.http.post('/api/machine-list/' + id + '/upload', formData);
    }
    public getMachineAttachment(id): Observable<any> {
        return  this.http.get('/api/machine-list/download/' + id, {
            responseType: 'blob' as 'json',
            observe: 'response',
        });
    }
    public downloadMachineList(typeId: string): Observable<any> {
        return this.http.get('/api/machine-pdf', {
            params: {typeId: typeId},
            responseType: 'blob' as 'json',
            observe: 'response',
        });
    }

    public downloadMachineListCsv(typeId: string): Observable<any> {
        return this.http.get('/api/machine-csv', {
            params: {typeId: typeId},
            responseType: 'blob' as 'json',
            observe: 'response',
        });
    }


    /*** MachineType */
    public getMachineType(): Observable<any>{
        return this.http.get('/api/machine-type');
    }

    public postMachineType(data): Observable<any>{
        return this.http.post('/api/machine-type', data);
    }

    public putMachineType(id, data): Observable<any>{
        return this.http.put('/api/machine-type/' + id, data);
    }

    public deleteMachineType(id): Observable<any> {
        return this.http.delete('/api/machine-type/' + id);

    }
    /*** MachineColumn */
    public getMachineColumn(): Observable<any> {
        return this.http.get('/api/machine-column');
    }

    public putMachineColumn(id, data): Observable<any>{
        return this.http.put('/api/machine-column/' + id, data);
    }
    /*** TechnicalControl */
    public putTechnicalControl(id, data): Observable<any> {
        return this.http.put('/api/technical-control-list/' + id, data);
    }
    public deleteTechnicalControl(id): Observable<any> {
        return this.http.delete('/api/technical-control-list/' + id);
    }
    public getTechnicalControl(id): Observable<any> {
        return this.http.get('/api/technical-control-list/' + id);
    }
    public postTechnicalControl(data): Observable<any> {
        return this.http.post('/api/technical-control-list', data);
    }
    public postTechnicalControlAttachment(id, file): Observable<any> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return this.http.post('/api/technical-control-list/' + id + '/upload', formData);
    }
    public getTechnicalControlAttachment(id): Observable<any> {
        return  this.http.get('/api/technical-control-list/download/' + id, {
            responseType: 'blob' as 'json',
                observe: 'response',
        });
    }
    /*** Insurance */
    public getInsurance(id): Observable<any> {
        return this.http.get('/api/insurance-list/' + id);
    }
    public putInsurance(id, data): Observable<any> {
        return this.http.put('/api/insurance-list/' + id, data);
    }
    public deleteInsurance(id): Observable<any> {
        return this.http.delete('/api/insurance-list/' + id);
    }
    public postInsurance(data): Observable<any> {
        return this.http.post('/api/insurance-list', data);
    }
    public postInsuranceAttachment(id, file): Observable<any> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return this.http.post('/api/insurance-list/' + id + '/upload', formData);
    }
    public getInsuranceAttachment(id): Observable<any> {
        return  this.http.get('/api/insurance-list/download/' + id, {
            responseType: 'blob' as 'json',
            observe: 'response',
        });
    }
    /*** Insurance Event */
    public getInsuranceEvent(id): Observable<any> {
        return this.http.get('/api/insurance-event/' + id);
    }
    public putInsuranceEvent(id, data): Observable<any> {
        return this.http.put('/api/insurance-event/' + id, data);
    }
    public postInsuranceEvent(data): Observable<any> {
        return this.http.post('/api/insurance-event', data);
    }
    public deleteInsuranceEvent(id): Observable<any> {
        return this.http.delete('/api/insurance-event/' + id);
    }
    public postInsuranceEventAttachment(id, file): Observable<any> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return this.http.post('/api/insurance-event/' + id + '/upload', formData);
    }
    public getInsuranceEventAttachment(id): Observable<any> {
        return  this.http.get('/api/insurance-event/download/' + id, {
            responseType: 'blob' as 'json',
            observe: 'response',
        });
    }

}
